import './hero.css'

import { useDatabase } from '../../hooks/useDatabase';

import SocialLinks from '../SocialLinks/SocialLinks';
import ShapeGenerator from '../ShapeGenerator/ShapeGenerator';
import { scrollToSection, scrollToSectionEvent } from "../../helpers/utilities";

export default function Hero() {
    const db = useDatabase();

    return (
        <section className="hero">
            <ShapeGenerator />
            <div className="inner">
                <div className="hero-content">
                    <img src={db.sections.hero.imageURL} alt={db.sections.hero.title} />
                    <h1>{db.sections.hero.title}</h1>
                    <h2>{db.sections.hero.subtitle}</h2>

                    <SocialLinks />

                    <a className="btn" href="#" onClick={(e) => scrollToSectionEvent(e, document.querySelector(".contact-panel"))}>Contact</a>
                </div>
                <div className="scroll-down" onClick={() => scrollToSection(document.querySelectorAll("section")[1])}>
                    <p>Scroll Down</p>
                    <div className="scroll-indicator"><span></span></div>
                </div>
            </div>
        </section>
    );
}